/* eslint-disable */
import { HttpClient, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { structuralClone } from '../../api-helpers';
import { DashboardTileUpdateMultipartBody, fixDashboardTileUpdateMultipartBodyToJson } from '../dto/dashboard-tile-update-multipart-body';

export interface PostDashboardTileUpdateParams {
  body: DashboardTileUpdateMultipartBody;
}

export function httpPostDashboardTileUpdate(http: HttpClient, data: PostDashboardTileUpdateParams, options?: { reportProgress?: boolean; observe?: 'body' }): Observable<void>;
export function httpPostDashboardTileUpdate(http: HttpClient, data: PostDashboardTileUpdateParams, options?: { reportProgress?: boolean; observe?: 'events' }): Observable<HttpEvent<void>>;
export function httpPostDashboardTileUpdate(http: HttpClient, data: PostDashboardTileUpdateParams, options: { reportProgress?: boolean; observe?: 'body' | 'events' } = {}): Observable<any> {
  return structuralClone(data).pipe(
    switchMap((dataClone) => {
      fixDashboardTileUpdateMultipartBodyToJson(dataClone.body);
      const body = dataClone.body;
      const form = new FormData();
      if (body.id != null) {
        form.append('Id', body.id as unknown as string);
      }
      if (body.internalName != null) {
        form.append('InternalName', body.internalName as unknown as string);
      }
      if (body.requiredProductShorthands != null) {
        body.requiredProductShorthands.forEach((obj,idx) => {form.append('RequiredProductShorthands', obj as unknown as string)});
      }
      if (body.dashboardTileCategory != null) {
        form.append('DashboardTileCategory', body.dashboardTileCategory as unknown as string);
      }
      if (body.validFromDate != null) {
        form.append('ValidFromDate', body.validFromDate.toISOString() as unknown as string);
      }
      if (body.expireDate != null) {
        form.append('ExpireDate', body.expireDate.toISOString() as unknown as string);
      }
      if (body.priority != null) {
        form.append('Priority', body.priority as unknown as string);
      }
      if (body.isWarning != null) {
        form.append('IsWarning', body.isWarning as unknown as string);
      }
      if (body.showOnDashboard != null) {
        form.append('ShowOnDashboard', body.showOnDashboard as unknown as string);
      }
      if (body.showInApi != null) {
        form.append('ShowInApi', body.showInApi as unknown as string);
      }
      if (body.contentPerLanguage != null) {
        body.contentPerLanguage.forEach((obj,idx) => {
          form.append(`ContentPerLanguage[${idx}].languageCode`, obj.languageCode as unknown as string);
          form.append(`ContentPerLanguage[${idx}].title`, obj.title as unknown as string);
          form.append(`ContentPerLanguage[${idx}].description`, obj.description as unknown as string);
          if (obj.buttonText !== null) form.append(`ContentPerLanguage[${idx}].buttonText`, obj.buttonText! as unknown as string);
          if (obj.buttonLinkUrl !== null) form.append(`ContentPerLanguage[${idx}].buttonLinkUrl`, obj.buttonLinkUrl! as unknown as string);
        });
      }
      if (body.image != null) {
        form.append('Image', body.image);
      }
      return http.post<void>(`{placeholder}/DashboardTile/Update`, form, options as any);
    })
  );
};

export const urlPostDashboardTileUpdate = (baseUrl: string, data: PostDashboardTileUpdateParams) => {
  return `${baseUrl}/DashboardTile/Update`;
};
